<template>
  <div class="detail-tab">
    <div class="tab-top">
      <div class="tab-list" :class="getTabValue === 'lectotype' ? 'active' : ''" @click="tabChange('lectotype')" v-if="hasLecto">选型样本</div>

      <div class="tab-list" :class="getTabValue === 'detail' ? 'active' : ''" @click="tabChange('detail')" v-if="compID != 0">产品详情</div>

      <div class="tab-list" :class="getTabValue === 'docs' ? 'active' : ''" @click="tabChange('docs')" v-if="productDocs.length > 0">图纸及附件</div>
      
      <!-- <div class="tab-list" :class="getTabValue === 'supplier' ? 'active' : ''" @click="tabChange('supplier')" v-if="compID == 0">供应商</div> -->

      <el-tooltip effect="dark" :content="islock ? '启用左右布局显示' : '禁用左右布局显示'" placement="left" v-if="isClient">
        <div class="fixed-icon" :class="islock ? 'fixed-m' : ''" @click="isLockChange">
          <i class="el-icon-lock" v-if="islock"></i>
          <i class="el-icon-unlock" v-else></i>
        </div>
      </el-tooltip>
      
    </div>

    <div class="tab-content" v-show="getTabValue === 'lectotype'" :style="{ overflowY: isAffix ? 'auto' : 'hidden', height: contentHeight }" v-if="hasLecto">
      <img title="双击查看大图" @dblclick="previewImg(index)" :src="item" alt="" v-for="(item, index) in lectotypeImgs" :key="item.ID">
    </div>
    <div class="tab-content" v-show="getTabValue === 'detail'" :style="{ overflowY: isAffix ? 'auto' : 'hidden', height: contentHeight }">
      <div v-html="productIntro"></div>
      <el-empty description="暂无产品详情" v-if="!productIntro"></el-empty>
    </div>
    <!-- 图纸及附件 -->
    <div class="tab-content" v-show="getTabValue === 'docs'" :style="{ overflowY: isAffix ? 'auto' : 'hidden', height: contentHeight }">
      <pro-docs v-bind="$attrs"></pro-docs>
    </div>

    <div class="tab-content" v-if="getTabValue === 'supplier'" :style="{ overflowY: isAffix ? 'auto' : 'hidden', height: 'calc(100vh - 56px)', padding: 0 }">
      <supplier-map></supplier-map>
    </div>


  </div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import { ApiService, OpenService } from '@/service';
import { getImgSrc } from '@/utils/utils';

import ProDocs from './proDocs.vue';
import SupplierMap from './supplierMap.vue';

export default {
  props: {
    document_list: { default: {} },
    productIntro: { default: '' },
    compID: { default: '' },
    isAffix: { default: false },
    islock: { default: 0 },
  },
  inject: ['productDocs'],
  components: { ProDocs, SupplierMap },
  data() {
    return {
      tabValue: 'lectotype',
      ApiService,
      isClient: CheckLibs.isClient()
    }
  },
  computed: {
    contentHeight() {
      if (this.islock && !this.isAffix) return 'auto';
      return this.compID == 0 ? 'calc(100vh - 56px)' : 'calc(100vh - 96px)';
    },
    // 选型样本是否存在
    hasLecto() {
      return !(this.document_list.sizes.length <= 0 && this.document_list.samples.length <= 0);
    },
    lectotypeImgs() {
      return this.document_list.sizes.concat(this.document_list.samples).map(item => (getImgSrc(item.FileServerPath, 0, false)))
    },
    getTabValue() {
      let tabValue = this.tabValue;
      if (!this.hasLecto && this.tabValue === 'lectotype') {
        tabValue = 'detail';
      }
      return tabValue;
    }
  },
  methods: {
    tabChange(value) {
      this.tabValue = value;

      if (value === 'supplier') {
        this.$emit('isLockChange', 1);
      } else {
        this.$emit('isLockChange', 0);
      }
    },
    isLockChange() {
      this.$emit('isLockChange', this.islock ? 0 : 1);
    },
    previewImg(index) {
      const images = this.lectotypeImgs;
      console.log(index, images)
      OpenService.openImgPreview(index, images)
    },
  }
}
</script>

<style lang="less" scoped>
.detail-tab{
  width: 100%;
  background: #FFFFFF;
  box-shadow: 0px 0px 14px 0px #EAEEFF;
  border: 1px solid #D6D6D6;
}
.tab-top{
  height: 36px;
  background: #F1F1F1;
  border: 1px solid #D6D6D6;
  display: flex;
  flex-direction: row;
  position: relative;
}
.tab-list{
  width: 165px;
  height: 100%;
  color: @text-color-base;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
  position: relative;
  &.active{
    background: #ffffff;
  }
  &.active::before{
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background: #C3A271;
    position: absolute;
    left: 0;
    top: -1px;
    z-index: 1;
  }
  &.active::after{
    content: '';
    display: block;
    width: 100%;
    height: 2px;
    background: #ffffff;
    position: absolute;
    left: 0;
    bottom: -1px;
    z-index: 1;
  }
}
.tab-content{
  padding: 20px;
  /deep/ img{
    width: 100%;
  }
}
.fixed-icon{
  position: absolute;
  right: 5px;
  top: 4px;
  width: 26px;
  height: 26px;
  line-height: 25px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  &.fixed-m{
    background: #fff;
  }
}
</style>
